import { createSelector } from 'reselect';
import {
  getDrawProps,
  getMyDrawEntity,
  getMyTeamEntity,
} from '../pairingSelector';
import {
  DrawMyArmyView,
  DrawPropositionView,
  DrawSelectionView,
  DrawView,
} from './view/DrawView';
import { TeamArmyView } from '../create/view/TeamArmyView';

export const drawPresenter = createSelector(
  [getDrawProps, getMyTeamEntity, getMyDrawEntity],
  (drawProps, myTeam, myDraw): DrawView => {
    return new DrawView({
      displayDraw: drawProps.displayDraw,
      displayResponse: drawProps.displayResponse,
      item: drawProps.draw,
      my: drawProps.my,
      teamArmy: new DrawMyArmyView({
        teamArmy: TeamArmyView.fromTeamArmy(drawProps.draw?.myTeamArmy ?? null),
        selected:
          drawProps.my &&
          drawProps.displayDraw &&
          drawProps.draw?.myTeamArmyId != null &&
          !(drawProps.draw?.myTeamArmyConfirmed ?? false),
        confirmed: drawProps.draw?.myTeamArmyConfirmed ?? false,
      }),
      proposition: new DrawPropositionView({
        teamArmyOne: drawProps.draw?.propositionTeamArmyOne
          ? TeamArmyView.fromTeamArmy(
              drawProps.draw?.propositionTeamArmyOne,
              drawProps.selectable &&
                !(myDraw?.selectedTeamArmyConfirmed ?? false),
              drawProps.displaySelected &&
                (drawProps.draw?.propositionTeamArmyConfirmed ?? false) &&
                drawProps.draw?.propositionTeamArmyOneId ===
                  drawProps.draw?.selectedTeamArmyId,
            )
          : null,
        teamArmyTwo: drawProps.draw?.propositionTeamArmyTwo
          ? TeamArmyView.fromTeamArmy(
              drawProps.draw?.propositionTeamArmyTwo,
              drawProps.selectable &&
                !(myDraw?.selectedTeamArmyConfirmed ?? false),
              drawProps.displaySelected &&
                (drawProps.draw?.propositionTeamArmyConfirmed ?? false) &&
                drawProps.draw?.propositionTeamArmyTwoId ===
                  drawProps.draw?.selectedTeamArmyId,
            )
          : null,
        selected:
          !drawProps.my &&
          drawProps.displayResponse &&
          drawProps.draw?.propositionTeamArmyOneId != null &&
          drawProps.draw?.propositionTeamArmyTwoId != null &&
          !(drawProps.draw?.propositionTeamArmyConfirmed ?? false),
        confirmed: drawProps.draw?.propositionTeamArmyConfirmed ?? false,
      }),
      selection: new DrawSelectionView({
        teamArmy: drawProps.draw?.selectedTeamArmy
          ? TeamArmyView.fromTeamArmy(drawProps.draw?.selectedTeamArmy)
          : null,
        selected:
          drawProps.displayResponse &&
          drawProps.draw?.selectedTeamArmyId != null &&
          !(drawProps.draw?.selectedTeamArmyConfirmed ?? false),
        confirmed: drawProps.draw?.selectedTeamArmyConfirmed ?? false,
      }),
    });
  },
);
